import { Button, Tooltip, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { red } from "../../theme";

interface IActionButtonProps {
  local_error: string | null;
  action(): void;
  name: string;
  disabled?: boolean;
  tooltip?: string
}
export function ActionButton(props: IActionButtonProps) {
  const { local_error, action, name, disabled, tooltip } = props;

  return (
    <Grid container direction="row" justifyContent="center" alignItems="center" spacing={2}>
      <Grid xs={12} item sx={{}}>
        <Tooltip title={tooltip}>
          <span>
        <Button variant="contained" disabled={disabled} onClick={action} type="button" color="primary" sx={{ width: "100%" }}>
          {name}
        </Button>
        </span>
        </Tooltip>
      </Grid>
      <Grid sm={12}  item style={{}}>
        <Typography textAlign={"center"} sx={{ color: red }}>
          {local_error}
        </Typography>
      </Grid>
    </Grid>
  );
}